import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x01800000 {
  chipID: string;
  deviceID: number;
  hasNewVersion: string;
}

export function Command0x01800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    chipID: "",
    deviceID: 0,
    hasNewVersion: "",
  };

  const [fields, setFields] = React.useState<Form0x01800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x01800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.chipID) {
      params.chipID = "";
    }
    if (!params.deviceID) {
      params.deviceID = 0;
    }
    if (!params.hasNewVersion) {
      params.hasNewVersion = "";
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          id="chipID"
          label="ID чипа"
          margin="dense"
          fullWidth
          value={fields.chipID}
          onChange={handleChangeField("chipID")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          id="deviceID"
          label="ID контроллера в системе AXIoT"
          margin="dense"
          fullWidth
          value={fields.deviceID}
          onChange={handleChangeField("deviceID")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          id="hasNewVersion"
          label="Обновить прошивку?"
          margin="dense"
          fullWidth
          value={fields.hasNewVersion}
          onChange={handleChangeField("hasNewVersion")}
          helperText="0x55 - если нужно принудительно залить прошивку, 0x00 - если нет"
        />
      </FormControl>
    </>
  );
}
